import copy from "./copy";

export default function(app) {
  app.directive("copy", copy);
};
